import * as constants from '../actions/constants';
import { EmployeeActions } from '../actions/employeeActions';
import { IEmployee, IEmployeeCostRate, IInvolvementEmployees } from '../types/employee';
import { IPagination } from '../../../types/pagination';

export const _initialEmployee: IEmployee = {
  id: '',
  username: '',
  full_name: '',
  first_name: '',
  last_name: '',
  photo: '',
  department_name: '',
  department_id: '',
  email: '',
  last_activity: '',
  active: true,
  invited: '',
  roles: [],
  deleted_on: null,
  inactive_on: null,
  reports: [],
  notifications_via_email: false, 
  color: ''
}
const initialInvolvementEmployee: IInvolvementEmployees = {
  employee: _initialEmployee,
  activities_count: '0',
  booked_hours: '0'
}
const initialEmployees: IEmployee[] = [_initialEmployee]
const initialInvolvementEmployees: IInvolvementEmployees[] = [initialInvolvementEmployee]
const initialEmployeePagination: IPagination<IEmployee[]> = {
  links: { next: '', previous: '' },
  count: 0,
  current_page: 0,
  total_pages: 0,
  results: initialEmployees,
  page_size: 5,
  last_page: 0,
  to: 0,
  from: 0
}
const initialInvolvementEmployeesPagination: IPagination<IInvolvementEmployees[]> = {
  links: { next: '', previous: '' },
  count: 0,
  current_page: 0,
  total_pages: 0,
  results: initialInvolvementEmployees,
  page_size: 5,
  last_page: 0,
  to: 0,
  from: 0
}
export const _initialCostRate: IEmployeeCostRate = {
  id: '',
  cost_rate: '',
  start_date: null,
  end_date: null
}

export const employees = (state: IEmployee[] = initialEmployees, action: EmployeeActions): IEmployee[] => {
  switch (action.type) {
    case constants.GET_EMPLOYEES_SUCCESS:
      return action.employees

    case constants.UPDATE_EMPLOYEE_SUCCESS:
      return state.map(dep => {
        if (dep.id === action.employee.id) {
          return action.employee
        }
        return dep
      })

    case constants.CREATE_EMPLOYEE_SUCCESS:
     return [...state, action.employee]

    case constants.DELETE_EMPLOYEE_SUCCESS:
      return state.filter(dep => dep.id !== action.employee.id)

    default:
      return state
  }
}

export const employeePagination = (state: IPagination<IEmployee[]> = initialEmployeePagination, action: EmployeeActions): IPagination<IEmployee[]> => {
  switch (action.type) {
    case constants.GET_PAGINATED_EMPLOYEES_SUCCESS:
      return action.employees

    default:
      return state
  }
}

export const sortEmployees = (state: { name: string, direction: string} = { name: '', direction: ''}, action: EmployeeActions): { name: string, direction: string } => {
  switch (action.type) {
    case constants.SORT_EMPLOYEES:
      return action.sort

    default:
      return state
  }
}

export const filterEmployees = (state = '', action: EmployeeActions): string => {
  switch (action.type) {
    case constants.FILTER_EMPLOYEES:
      return action.search

    default:
      return state
  }
}

export const selectedEmployee = (state = _initialEmployee , action: EmployeeActions): IEmployee => {
  switch (action.type) {
    case constants.GET_EMPLOYEE_SUCCESS:
    case constants.SELECT_EMPLOYEE:
    case constants.CREATE_EMPLOYEE_SUCCESS:
    case constants.UPDATE_EMPLOYEE_SUCCESS:
    case constants.UPDATE_EMPLOYEE_PHOTO_SUCCESS:
      return action.employee

    case constants.REMOVE_EMPLOYEE_PHOTO_SUCCESS:
      return {...state, photo: '' }
    default:
      return state
  }
}

export const openEmployeeForm = (state = false, action: EmployeeActions): boolean => {
  switch (action.type) {
    case constants.OPEN_EMPLOYEE_FORM:
      return action.open
    case constants.CREATE_EMPLOYEE_SUCCESS:
    case constants.UPDATE_EMPLOYEE_SUCCESS:
      return false

    default:
      return state
  }
}

export const employeeActivePage = (state = 1, action: EmployeeActions): number => {
  switch (action.type) {
    case constants.SET_EMPLOYEE_ACTIVE_PAGE:
      return action.page

    default:
      return state
  }
}

export const openProjectEmployees = (state: IEmployee[] = initialEmployees, action: EmployeeActions): IEmployee[] => {
  switch (action.type) {
    case constants.GET_EMPLOYEES_OPEN_PROJECT_SUCCESS:
      return action.employees

    default:
      return state
  }
}

export const openPaginatedProjectEmployees = (state: IPagination<IEmployee[]> = initialEmployeePagination, action: EmployeeActions): IPagination<IEmployee[]> => {
  switch (action.type) {
    case constants.GET_PAGINATED_EMPLOYEES_OPEN_PROJECT_SUCCESS:
      return action.employees

    default:
      return state
  }
}

export const paginatedEmployeeActivePage = (state = 1, action: EmployeeActions): number => {
  switch (action.type) {
    case constants.SET_PAGINATED_EMPLOYEES_OPEN_PROJECT_ACTIVE_PAGE:
      return action.page

    default:
      return state
  }
}

export const involvementEmployees = (state: IInvolvementEmployees[] = initialInvolvementEmployees, action: EmployeeActions): IInvolvementEmployees[] => {
  switch (action.type) {
    case constants.GET_INVOLVEMENT_EMPLOYEES_SUCCESS:
      return action.involvementEmployees

    default:
      return state
  }
}

export const paginatedInvolvementEmployees = (state: IPagination<IInvolvementEmployees[]> = initialInvolvementEmployeesPagination, action: EmployeeActions): IPagination<IInvolvementEmployees[]> => {
  switch (action.type) {
    case constants.GET_PAGINATED_INVOLVEMENT_EMPLOYEES_SUCCESS:
      return action.employees

    default:
      return state
  }
}

export const paginatedInvolvementEmployeeActivePage = (state = 1, action: EmployeeActions): number => {
  switch (action.type) {
    case constants.SET_PAGINATED_INVOLVEMENT_EMPLOYEES_ACTIVE_PAGE:
      return action.page

    default:
      return state
  }
}
